import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import HeartButton from "@/components/HeartButton";
import { useLocale } from "@/context/LocaleContext";

export default function ProductCard({ product, index = 0, instant = false }) {
  const { formatMoney } = useLocale() || { formatMoney: (n) => `$${n}` };
  const img = imgUrl(product.image || product.images?.[0]);
  const eager = instant && index < 8;
  return (
    <Link
      to={`/product/${encodeURIComponent(product.id)}`}
      state={{ product }}
      className={`group flex h-full flex-col ${instant ? "" : "fade-up"}`}
      style={instant ? undefined : { animationDelay: `${Math.min(index, 8) * 60}ms` }}
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-white">
        {img ? (
          <img
            referrerPolicy="no-referrer"
            src={img}
            alt={product.title}
            className="absolute inset-0 h-full w-full object-cover"
            loading={eager ? "eager" : "lazy"}
            fetchPriority={eager ? "high" : "auto"}
            decoding="async"
          />
        ) : (
          <div className="absolute inset-0 shimmer" />
        )}
        {(product.quantity ?? 1) <= 0 && !product.external ? (
          <span className="absolute top-3 left-3 glass text-[10px] tracking-luxe uppercase px-2.5 py-1">Sold out</span>
        ) : product.is_live ? (
          <span className="absolute top-3 left-3 neon-live rounded-full bg-aura-accent text-white text-[10px] tracking-luxe uppercase px-2.5 py-1 flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-white dot-blink" /> Live
          </span>
        ) : null}
        {product.external && !product.is_live && (
          <span className="absolute top-3 left-3 glass text-[10px] tracking-luxe uppercase px-2.5 py-1">
            Partner
          </span>
        )}
        <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
          <HeartButton productId={product.id} />
        </div>
        {product.offer_count > 1 && (
          <span className="absolute bottom-3 right-3 glass text-[10px] tracking-luxe uppercase px-2.5 py-1">
            {product.offer_count} offers
          </span>
        )}
        <span className="absolute bottom-3 left-3 glass text-[10px] tracking-luxe uppercase px-2.5 py-1 opacity-0 group-hover:opacity-100 transition-opacity">
          {product.category}
        </span>
      </div>
      <div className="mt-3 flex min-h-[4.75rem] items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="min-h-[2.5rem] font-serif text-base leading-tight line-clamp-2">{product.title}</h3>
          <p className="mt-0.5 h-4 truncate text-xs text-aura-muted">{product.brand || product.seller_name}</p>
        </div>
        <div className="mt-0.5 shrink-0 font-mono text-sm">{formatMoney(product.price, product.currency || "USD")}</div>
      </div>
    </Link>
  );
}
